<style lang="scss">
  .monitorMachineMoldTable .el-progress-bar__outer {
    background: #606672;
  }

  .monitorMachineMoldTable .el-progress__text {
    color: #ffffff;
  }

  .monitorMachineMoldTable::before {
    z-index: inherit;
  }

  .monitorMachineMoldTable.el-table {
    background-color: transparent;
  }

  .monitorMachineMoldTable.el-table--border:after,
  .monitorMachineMoldTable.el-table--group:after,
  .monitorMachineMoldTable.el-table:before {
    background-color: transparent;
  }

  .monitorMachineMoldTable.el-table tr {
    background-color: transparent;
  }

  .monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #33333a !important;
  }

  .monitorMachineMoldTable .el-table td.gutter,
  .monitorMachineMoldTable.el-table th.gutter {
    background: transparent;
  }

  //.monitorMachineMoldTable .el-table__body-wrapper {
  //  background: #1d1d24;
  //}

  // 滚动条的宽度
  .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
    width: 2px; // 横向滚动条
  }

  // 滚动条的滑块
  .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #419fff;
    border-radius: 2px;
  }

  /*滚动条里面轨道*/
  // .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
  // 	border-radius: 2px;
  // 	background: #1D1D24;
  // }
</style>

<style lang="scss" scoped="scoped">
  .cell-class-name {
    border-bottom: 1px solid red !important;
  }
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;background: #1D1D24" >
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('tiaoji') }}
        </p>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorMachineMoldTable" :data="$attrs.adjustMachineList" style="width: 100%" :max-height="contentHeight" :row-style="{ background: '#1d1d24', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'transparent', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: '#33333A', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '14px' }" cell-class-name="cell-class-name">
<!--        <el-table-column prop="equipmentName" :label="$t('shebeimingcheng')"> </el-table-column>-->
        <el-table-column :label="$t('shebeimingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.equipmentName) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('shengchangongdanhao')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.no) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mujubianhao')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mouldCode) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mujumingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mouldName) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chanpinbianma')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.materialCode) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chanpinmingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.materialName) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('zhuanmojieshushijian')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{scope.row.dieChangeEndTime==null?'':dayjs(scope.row.dieChangeEndTime).format('YYYY-MM-DD HH:mm:ss')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('tiaojikaishishijian')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{scope.row.debugEquipmentStartTime==null?'':dayjs(scope.row.debugEquipmentStartTime).format('YYYY-MM-DD HH:mm:ss')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('tiaojizhuangtai')">
          <template slot-scope="scope">
            <div style="font-weight: bold;font-size: 15px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;border:1px solid rgba(255, 58, 94, 1)" :style="{ color: textColor[scope.row.debugEquipmentStatus], 'border-color': textColor[scope.row.debugEquipmentStatus], 'background-color': bgColor[scope.row.debugEquipmentStatus] }">
              {{ $t(store.state.dictJsonAll['PREPARATION_DEBUG_EQUIPMENT_STATUS'][scope.row.debugEquipmentStatus]) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    name: 'web_customize_weier_monitor_production_preparation_adjust_machine',
    components: {},
    // watch: {
    //   '$attrs.orgId'(newValue, oldValue) {
    //     if (this.utils.isEqual(newValue, oldValue)) {
    //       return;
    //     }
    //     this.listData();
    //   }
    // },
    data() {
      return {
        textColor: { '0': 'rgba(255, 58, 94, 1)', '1': 'rgba(255, 200, 58, 1)', '2': 'rgba(57, 241, 109, 1)'},
        bgColor: { '0': 'rgba(255, 58, 94, 0.2)', '1': 'rgba(255, 200, 58, 0.2)', '2': 'rgba(57, 241, 109, 0.2)'},
        interval: null,
        timer: null,
        contentHeight: 0,
        rowHeight: 0,
        // list: [],

        isStopListScroll: false
      };
    },
    created() {
      // this.timer = setInterval(() => {
      //   this.listData();
      // }, 120000);
      // this.listData();
    },
    mounted() {
      this.resize();
      this.utils.event_hub.$on('RESIZE', () => {
        this.resize();
      });
      this.setAutoScroll();
    },
    // destroyed() {
    //   if (this.timer) {
    //     clearInterval(this.timer);
    //   }
    // },
    methods: {
      // async listData() {
      //   let response = await this.http.get('/web/report/page/board_repair_record?status=1&pageSize=999', {
      //     params: {
      //       //orgId: this.$attrs.orgId,
      //     }
      //   });
      //   this.list = response.data.rows;
      // },
      setAutoScroll() {
        if (this.interval) {
          clearInterval(this.interval);
        }
        const listDiv = this.$refs.table.bodyWrapper;
        this.interval = setInterval(() => {
          if (!this.store.state.is_monitor_full) {
            return;
          }
          if (!this.isStopListScroll) {
            listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
            if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
              this.isStopListScroll = true;
              setTimeout(() => {
                if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                  listDiv.scrollTop = 0;
                }
                this.isStopListScroll = false;
              }, 5000);
            }
          }
        }, 100);
      },
      resize() {
        //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
        setTimeout(() => {
          if (!this.$refs.titleBar) {
            return;
          }
          this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
          this.rowHeight = (this.contentHeight - 42 - 5) / 4;
        }, 800);
      }
    }
  };
</script>
